import type { SVGProps } from "react";
export default function SvgApps(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 24 24"
			{...props}
		>
			<g
				stroke="black"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1.3}
				clipPath="url(#clip0_498_1793)"
			>
				<path d="M9 13.51H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1" />
				<path d="M21 13.51h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1" />
				<path d="M9 2H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1" />
				<path d="m16.843 1.157-4.675 4.675a.944.944 0 0 0 0 1.336l4.675 4.675a.944.944 0 0 0 1.335 0l4.675-4.675a.944.944 0 0 0 0-1.336l-4.675-4.675a.944.944 0 0 0-1.335 0" />
			</g>
			<defs>
				<clipPath id="clip0_498_1793">
					<rect width={24} height={24} fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
